import { useEffect, useState } from 'react';
import { getCampaignList } from 'src/common/Scraper';
import { useNavigate } from 'react-router-dom';
import { useCitation } from '../Providers/CitationProvider';
import { Campaign } from '../types';

interface UseGetCitationsResponse {
  isFetching: boolean;
  campaignList: Campaign[];
}

export const useGetCitations = (): UseGetCitationsResponse => {
  const navigate = useNavigate();

  const { setCampaignList, state: citationState } = useCitation();

  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    if (citationState?.campaignList?.length > 0) {
      setIsFetching(false);
      return;
    } else {
      (async () => {
        try {
          setIsFetching(true);
          const { status, response } = await getCampaignList();

          if (status === 'success' && response?.campaigns?.length > 0) {
            setCampaignList(response?.campaigns);
            navigate('/local-seo/citations/list');
          }

          setIsFetching(false);
        } catch (error) {
        } finally {
          setIsFetching(false);
        }
      })();
    }
  }, []);

  return {
    isFetching,
    campaignList: citationState?.campaignList || []
  };
};
